module.exports = {
    extends: [
        '/',
        'base',
        'form',
        'form'
    ],

    config: {
        loadWhenPrimaryKeyPresentOnly: true,
        isFullyVertical: true,
    },
}